const changeSubscriptionModalEn = {
  title: 'Manage Subscription',
  closeAria: 'Close',
  loading: 'Loading…',
  notBilledStripe: 'This resource is not billed via Stripe.',
  upgradePaid: 'Upgrade to Paid Plan',
  loadingPrices: 'Loading prices…',
  selectPlan: 'Select a plan',
  upgradeNow: 'Upgrade Now',
  noUpgradeOptions: 'No upgrade options available.',
  currentSubscription: 'Current Subscription',
  status: 'Status:',
  cancelAtPeriodEndLabel: 'Cancel at period end:',
  yes: 'Yes',
  no: 'No',
  runsUntil: 'Runs until:',
  cancelAtPeriodEndBtn: 'Cancel at period end',
  titleAlreadyCanceling: 'Already canceling at period end',
  titleCancelAtPeriodEnd: 'Cancel at period end',
  restart: 'Restart',
  titleNotScheduled: 'Subscription is not scheduled to cancel',
  titleRestart: 'Restart subscription',
  extendChangePlan: 'Extend / change plan after current period',
  selectNextPlan: 'Select next plan',
  scheduleChange: 'Schedule change',
  upgradeChangePlan: 'Upgrade / Change Plan',
  changePlanNow: 'Change Plan Now',
  cancelModalTitle: 'Cancel subscription at period end',
  cancelModalDesc:
    'This will keep the resource active until the end of the current billing period.',
  reasonRequired: 'Reason (required)',
  placeholderWhy: 'Why are you canceling?',
  close: 'Close',
  confirmCancel: 'Confirm cancel',
  reasonRequiredErr: 'Cancellation reason is required.',
  cancelFailed: 'Failed to cancel subscription.',
  cancelSuccess: 'Subscription will cancel at the end of the current period.',
  restartFailed: 'Failed to restart subscription.',
  restartSuccess: 'Subscription restart requested.',
  selectNextPlanErr: 'Please select a next plan.',
  scheduleFailed: 'Failed to schedule plan change.',
  scheduleSuccess: 'Plan change scheduled for after the current period ends.',
  selectPlanUpgradeErr: 'Please select a plan to upgrade to.',
  createSubFailed: 'Failed to create subscription.',
  createSubSuccess: 'Subscription created successfully.',
  updateSubFailed: 'Failed to update subscription.',
  updateSubSuccess: 'Subscription updated successfully.',
  upgradeFailed: 'Failed to upgrade subscription.',
};

export default changeSubscriptionModalEn;
